var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"ml-1",attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarAlternarContrato()}}},[_c('span',[_c('i',{staticClass:"fa fa-refresh mr-2"}),_vm._v("\n        "+_vm._s(_vm.titulo)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }